<template>
  <!-- The client portal's bar: home, the page title, the list/map switch with the map's
       style, and the profile menu -->
  <!-- the regular bar's height (64px + its border), so client and staff pages line up -->
  <v-toolbar
    flat
    border="b"
    class="client-top-bar"
  >
    <v-btn
      :to="getAccountRoute({ name: 'client-occupiers-list' })"
      icon="mdi-home-outline"
      variant="text"
      :active="false"
      title="Occupiers"
      aria-label="Occupiers"
    />
    <v-toolbar-title v-if="pageTitle" class="client-top-bar__title">{{ pageTitle }}</v-toolbar-title>
    <v-spacer />
    <!-- the same Map switch and map style menu as the list pages' filters panel -->
    <AppFiltersPanelMapSwitch v-if="showMapSwitch" @update:view-mode="$emit('update:viewMode', $event)" />
    <ProfileMenuWrapper />
  </v-toolbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';

import AppFiltersPanelMapSwitch from '@/bundles/Panels/components/groupFilters/AppFiltersPanelMapSwitch.vue';
import ProfileMenuWrapper from '@/bundles/Panels/components/ProfileMenuWrapper.vue';

export default defineComponent({
  name: 'AppTopPanelClient',

  components: { AppFiltersPanelMapSwitch, ProfileMenuWrapper },
  mixins: [AccountLayoutMixin],

  props: {
    viewMode: {
      type: String,
      default: null
    },
    showMapSwitch: Boolean,
  },

  emits: ['update:viewMode'],

  computed: {
    // the route's own title ("Occupiers", "Occupier")
    pageTitle (): string {
      return (this.$route.meta.topBarTitle || this.$route.meta.title || '') as string;
    },
  },
});
</script>

<style scoped>
/* spaced by one gap, like the regular top bar, instead of a margin on each control; Vuetify's
   own toolbar margins (-12px on the first button, 10px+ before the title) are cleared */
.client-top-bar :deep(.v-toolbar__content) {
  gap: 8px;
  padding-inline: 8px;
}

.client-top-bar :deep(.v-toolbar__content > *) {
  margin-inline: 0 !important;
}

.client-top-bar__title {
  font-size: 1.125rem;
}
</style>
